import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import ProcessField from 'components/core/fields/ProcessField';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import ProcessUtils from 'utils/ProcessUtils';
import Constants from 'utils/Constants';
import _ from 'lodash';

export default class DimensionInputDatasetField extends ProcessField {
    static propTypes = Object.assign({
        coordinateSystemName: PropTypes.string.isRequired,
        dimensionName: PropTypes.string.isRequired,
        displayPrimaryDatastreamOnly: PropTypes.bool
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
        displayPrimaryDatastreamOnly: false
    }, ProcessField.defaultProps);

    getInputDatsetOptions = () => {
        const inputDatasetOptions = [];
        const usedDatastreams = [];
        let inputDatasetList = [];

        if (this.props.dimensionName === 'time') {
            // All dods should have time dimension, so show all input datasets in dropdown list
            inputDatasetList = Object.keys(this.props.process.variable_retrieval.input_datasets);

        } else {
            // If this is non-time dimension, then only let user choose from datasets that also have
            // a non-time dimension
            inputDatasetList = ProcessUtils.getDatasetsWithNonTimeDimension(this.props.process);
        }

        inputDatasetList.forEach(inputDatasetName => {
            const inputDataset = this.props.process.variable_retrieval.input_datasets[inputDatasetName];
            // Add the datastream for the first (primary) rule of each input dataset
            const primaryDatastream = ProcessUtils.getPrimaryDatastream(this.props.process, inputDataset.name);

            if (inputDataset.rules && inputDataset.rules.length > 0) {
                const label = this.getInputDatasetLabel(inputDatasetName);
                const option = { value: inputDataset.name, label };

                if (this.props.displayPrimaryDatastreamOnly) {
                    // Some processes have the same datastream used in more than one input dataset.  For now, we
                    // just pick the first one.
                    if (!_.includes(usedDatastreams, primaryDatastream) && !_.includes(inputDatasetOptions, option)) {
                        inputDatasetOptions.push(option);
                        usedDatastreams.push(primaryDatastream);
                    }
                } else {
                    let exists = false;
                    inputDatasetOptions.forEach(existingOption => {
                        if (existingOption.value === option.value) {
                            exists = true;
                        }
                    });

                    if (!exists) {
                        inputDatasetOptions.push(option);
                    }
                }
            }
        });

        return inputDatasetOptions;
    };

    getInputDatasetLabel = (inputDatasetName) => {
        const primaryDatastream = ProcessUtils.getPrimaryDatastream(this.props.process, inputDatasetName);
        return this.props.displayPrimaryDatastreamOnly ? primaryDatastream : `${inputDatasetName} [${primaryDatastream}]`;
    };

    onInputDatasetChanged = (fieldPath, valueObject) => {
        const inputDatasetName = valueObject.value;
        const editor = ProcessUtils.getEditor(this.props.process);
        editor.updateDimensionInputDataset(this.props.coordinateSystemName, this.props.dimensionName, inputDatasetName);
        editor.commit();
    };

    render() {
        const dimensionPath = ['variable_retrieval', 'coordinate_systems', this.props.coordinateSystemName, 'dimensions', this.props.dimensionName];
        const dimension = _.get(this.props.process, dimensionPath);

        const inputDatasetName = dimension.input_dataset;
        let inputDatasetValue = Constants.convertValueToSelectValue(null);

        if (inputDatasetName) {
            const label = this.getInputDatasetLabel(inputDatasetName);
            inputDatasetValue = { value: inputDatasetName, label };
        }

        const inputDatasetOptions = this.getInputDatsetOptions();

        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={cx('dimension-input-dataset', this.props.className)}>
                {this.props.displayLabel &&
                <InfoBoxLabel label="Datastream" />
                }
                <Flexbox flexDirection="column" flexGrow={1}>
                    <RIEComboBox
                        value={inputDatasetValue}
                        options={inputDatasetOptions}
                        change={this.onInputDatasetChanged}
                        fieldPath={['variable_retrieval', 'coordinate_systems', this.props.coordinateSystemName, 'dimensions', this.props.dimensionName, 'input_dataset']}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        formDisplay={this.props.forceFormDisplay}
                        isDisabled={!this.props.hasWritePermissions}
                    />
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/DimensionInputDatasetField.js